import { ApplicationDetailDomain } from '../store/ApplicationDetailDomain';

export const isAcceptRequirementAvailableExtension: IIsAcceptRequirementAvailableExtension[] = [
  (domain: ApplicationDetailDomain) => {
    return false;
  },
];

export interface IIsAcceptRequirementAvailableExtension {
  (domain: ApplicationDetailDomain): boolean;
}
